import React from "react";
import { MunicipalitySelect } from "@dhn/components/molecules/municipality-select";
import { ProvinceSelect } from "@dhn/components/molecules/province-select";
import { SectorSelect } from "@dhn/components/molecules/sector-select";
import ReactSelect from "react-select";
import { Col, Input, Label, Row } from "reactstrap";
import ReactFormat from "react-number-format";
import SelectableOption, {
  SelectableOptionGroup,
} from "@dhn/components/molecules/selectable-option";
import Schedule from "./Shedule/Schedule";
import SpecialityEvidenceTable from "./SpecialityEvidenceTable";
import RequiredDocumentsTable from "./RequiredDocumentsTable";
import ApprovedSpecialitiesTable from "./ApprovedSpecialitiesTable";
import DocumentsSizeProgress from "@dhn/components/molecules/documents-size-progress";
import { buildAuth0Username } from "../../../../../../utils/auth0-username";

const PASAPORTE_DOCUMENT_TYPE_ID = 4;
export default function Medical({
  isMedical,
  onChange,
  medicalSelected,
  profileOptions,
  profileSelected,
  schedulingFormat,
  addSchedule,
  scheduleSelected,
  isNew,
  documentTypeId,
  isAssociatedDoctorRequest,
  associatedDoctorDocuments = [],
  associatedDoctorSpecialities = [],
  associatedDoctorSpecialitySelected = null,
  associatedDoctorSpecialityDocuments = {},
  associatedDoctorSpecialityOptions = [],
  onAssociatedDoctorRequirementFileChange,
  onRemoveAssociatedDoctorDocument,
  onAssociatedDoctorSpecialitySelectedChange,
  onAddAssociatedDoctorSpeciality,
  onRemoveAssociatedDoctorSpeciality,
  onAssociatedDoctorSpecialityFileChange,
}) {
  const profileValue = React.useMemo(
    () =>
      profileOptions.find(
        (item) => Number(item?.id) === Number(profileSelected?.id || 0)
      ) || null,
    [profileOptions, profileSelected],
  );
  const isPassport = Number(documentTypeId) === PASAPORTE_DOCUMENT_TYPE_ID;
  const documentsTotalSize = React.useMemo(
    () =>
      [
        ...associatedDoctorDocuments,
        ...Object.values(associatedDoctorSpecialityDocuments),
      ].reduce(
        (total, document) => total + Number(document?.size || 0),
        0,
      ),
    [associatedDoctorDocuments, associatedDoctorSpecialityDocuments],
  );

  return (
    <React.Fragment>
      <Row form className="my-2">
        <Col>
          <Label>Primer Nombre:</Label>
          <Input
            disabled={!isMedical}
            onChange={({ target: { value } }) => {
              onChange("firstName", value, "medicalSelected");
              if (isNew) {
                onChange(
                  "username",
                  buildAuth0Username(
                    value,
                    medicalSelected?.lastName,
                    medicalSelected?.identificationCard,
                  ),
                  "medicalSelected",
                );
              }
            }}
            value={medicalSelected?.firstName || ""}
            placeholder="Escribir Nombre"
          />
        </Col>
        <Col>
          <Label>Segundo Nombre:</Label>
          <Input
            disabled={!isMedical}
            onChange={({ target: { value } }) =>
              onChange("middleName", value, "medicalSelected")
            }
            value={medicalSelected?.middleName || ""}
            placeholder="Escribir Nombre"
          />
        </Col>
        <Col>
          <Label>Primer Apellido:</Label>
          <Input
            disabled={!isMedical}
            onChange={({ target: { value } }) => {
              onChange("lastName", value, "medicalSelected");
              if (isNew) {
                onChange(
                  "username",
                  buildAuth0Username(
                    medicalSelected?.firstName,
                    value,
                    medicalSelected?.identificationCard,
                  ),
                  "medicalSelected",
                );
              }
            }}
            value={medicalSelected?.lastName || ""}
            placeholder="Escribir Apellido"
          />
        </Col>
        <Col>
          <Label>Segundo Apellido:</Label>
          <Input
            disabled={!isMedical}
            onChange={({ target: { value } }) =>
              onChange("lastName2", value, "medicalSelected")
            }
            value={medicalSelected?.lastName2 || ""}
            placeholder="Escribir Apellido"
          />
        </Col>
      </Row>

      <Row form className="my-2">
        <Col>
          <Label>{"Perfil:"}</Label>
          <ReactSelect
            placeholder="Seleccionar perfil"
            isDisabled={!isMedical}
            className="w-100"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item}
            options={profileOptions}
            value={profileValue}
            onChange={(v) => {
              onChange("profileSelected", v);
              onChange("profileId", v?.id || null, "medicalSelected");
            }}
          />
        </Col>
        <Col>
          <Label>Teléfono:</Label>
          <ReactFormat
            placeholder="Digitar Teléfono"
            className="bg-white"
            customInput={Input}
            format="(###) ###-####"
            displayType="input"
            onChange={({ target: { value } }) =>
              onChange("phone", value, "medicalSelected")
            }
            value={medicalSelected?.phone || ""}
            disabled={!isMedical}
          />
        </Col>
        <Col>
          <Label>Correo Electrónico:</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("email", value?.trim(), "medicalSelected")
            }
            value={medicalSelected?.email?.trim() || ""}
            placeholder="Escribir Correo Electrónico"
          />
        </Col>
      </Row>

      <Row form className="mb-2">
        <Col md={6}>
          <Label>Teléfono 2:</Label>
          <ReactFormat
            placeholder="Opcional"
            className="bg-white"
            customInput={Input}
            format="(###) ###-####"
            displayType="input"
            onChange={({ target: { value } }) =>
              onChange("phone2", value, "medicalSelected")
            }
            value={medicalSelected?.phone2 || ""}
            disabled={!isMedical}
          />
        </Col>
        <Col md={6}>
          <Label>Celular:</Label>
          <ReactFormat
            placeholder="Opcional"
            className="bg-white"
            customInput={Input}
            format="(###) ###-####"
            displayType="input"
            onChange={({ target: { value } }) =>
              onChange("cellphone", value, "medicalSelected")
            }
            value={medicalSelected?.cellphone || ""}
            disabled={!isMedical}
          />
        </Col>
      </Row>

      {!(isNew && isAssociatedDoctorRequest) && (
        <Row form className="mb-2">
          <Col>
            <ApprovedSpecialitiesTable
              specialities={medicalSelected?.specialities || []}
            />
          </Col>
        </Row>
      )}

      <Row form>
        <Col>
          <Label>Exequatur :</Label>
          <Input
            onChange={({ target: { value } }) =>
              onChange("exequatur", value, "medicalSelected")
            }
            value={medicalSelected?.exequatur || ""}
            placeholder="Escribir Exequatur "
          />
        </Col>
        <Col>
          <Label>{isPassport ? "Pasaporte" : "Cédula"}:</Label>
          {isPassport ? (
            <Input
              disabled
              className="mr-2"
              placeholder="Ingresar Número de Pasaporte"
              value={medicalSelected?.identificationCard || ""}
            />
          ) : (
            <ReactFormat
              disabled
              className="mr-2"
              placeholder="Ingresar Número de Cédula"
              customInput={Input}
              format={"###-#######-#"}
              value={medicalSelected?.identificationCard}
            />
          )}
        </Col>
        <Col>
          <Label>Usuario:</Label>
          <Input
            disabled
            onChange={({ target: { value } }) =>
              onChange("username", value, "medicalSelected")
            }
            value={medicalSelected?.username || ""}
            placeholder="Usuario"
          />
        </Col>
      </Row>

      <Row form className="mt-2">
        <Col sm="4">
          <ProvinceSelect
            item={{ id: medicalSelected?.provinceId }}
            onSelect={(item) =>
              onChange("provinceId", parseInt(item.id), "medicalSelected")
            }
          />
        </Col>
        <Col sm="4">
          <MunicipalitySelect
            item={{ id: medicalSelected?.municipalityId }}
            provinceId={medicalSelected?.provinceId}
            onSelect={(item) =>
              onChange("municipalityId", parseInt(item.id), "medicalSelected")
            }
          />
        </Col>
        <Col sm="4">
          <SectorSelect
            item={{ id: medicalSelected?.sectorId }}
            municipalityId={medicalSelected?.municipalityId}
            onSelect={(item) =>
              onChange("sectorId", parseInt(item.id), "medicalSelected")
            }
          />
        </Col>
      </Row>

      <Row form>
        <Col md={6}>
          <Label>Dirección</Label>
          <Input
            type="text"
            name="address"
            value={medicalSelected?.address || ""}
            placeholder="Ingresa la dirección"
            onChange={({ target }) =>
              onChange("address", target.value, "medicalSelected")
            }
          />
        </Col>

        <Col md={6}>
          <Label>Formato de Agendamiento</Label>
          <SelectableOptionGroup columns={2}>
            <SelectableOption
              key="scheduling-format-hour"
              compact
              icon="fa-clock-o"
              title="Por Hora"
              inputType="radio"
              inputName="schedulingFormat"
              checked={schedulingFormat === 2}
              onChange={({ target }) => {
                onChange(target.name, 2);
                setTimeout(() => {
                  document
                    .querySelector(".modal-footer")
                    .scrollIntoView({ behavior: "smooth", block: "end" });
                }, 100);
              }}
            />
            <SelectableOption
              key="scheduling-format-arrival"
              compact
              icon="fa-list-ol"
              title="Por Orden de Llegada"
              inputType="radio"
              inputName="schedulingFormat"
              checked={schedulingFormat === 1}
              onChange={({ target }) => {
                onChange(target.name, 1);
              }}
            />
          </SelectableOptionGroup>
        </Col>
        <Col>
          {schedulingFormat !== 0 && (
            <Schedule
              averageAppoimentTime={medicalSelected?.averageAppoimentTime}
              sheduleHeader={addSchedule}
              scheduleSelected={scheduleSelected}
              onChange={onChange}
              schedulingFormat={schedulingFormat}
            />
          )}
        </Col>
      </Row>
      {isNew && isMedical === 2 && (
        <>
          {isAssociatedDoctorRequest && (
            <>
              <hr />
              <Row form className="mt-2">
                <Col>
                  <SpecialityEvidenceTable
                    specialities={associatedDoctorSpecialities}
                    selectedSpeciality={associatedDoctorSpecialitySelected}
                    specialityDocuments={associatedDoctorSpecialityDocuments}
                    specialityOptions={associatedDoctorSpecialityOptions}
                    onSelectedSpecialityChange={onAssociatedDoctorSpecialitySelectedChange}
                    onAddSpeciality={onAddAssociatedDoctorSpeciality}
                    onRemoveSpeciality={onRemoveAssociatedDoctorSpeciality}
                    onSpecialityFileChange={onAssociatedDoctorSpecialityFileChange}
                  />
                </Col>
              </Row>
            </>
          )}
          <hr />
          <Row form className="mt-2">
            <Col>
              <RequiredDocumentsTable
                documents={associatedDoctorDocuments}
                onFileChange={onAssociatedDoctorRequirementFileChange}
                onRemoveDocument={onRemoveAssociatedDoctorDocument}
              />
            </Col>
          </Row>
          <Row form>
            <Col>
              <DocumentsSizeProgress totalSize={documentsTotalSize} />
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  );
}
